'use client'

import { useTranslations } from 'next-intl'

import { useSessionStorage } from '@/app/hooks/useSessionStorage'
import { STORAGE_KEY, TLocalizeVersion } from '@/app/constants'
import { getPortConfig } from '@/app/config/ports'

function ArrivalPortDisplay() {
  const t = useTranslations('Notifications')
  const tLocalization = useTranslations('localization')

  // Get localize version from session storage
  const [selectedLocalize] = useSessionStorage<TLocalizeVersion | null>(
    STORAGE_KEY.SELECTED_LOCALIZE_VERSION,
    null
  )

  // Get port name dynamically based on selected localize version
  const portConfig = selectedLocalize ? getPortConfig(selectedLocalize) : null
  const portName = portConfig
    ? tLocalization(`label.${portConfig.translationKey}`)
    : tLocalization('label.SANTOS') // Default to Santos

  // Determine the arrival port text based on selected localize version
  const arrivalPort = t('inPort', { port: portName })

  return <div>{arrivalPort}</div>
}

export default ArrivalPortDisplay
